let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lnpu0")).then(() => parcelRequire('4GqRf'));